var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"breadcrumbs__item",attrs:{"itemprop":"itemListElement","itemscope":"","itemtype":"https://schema.org/ListItem"}},[_c('a',{attrs:{"href":"/","itemprop":"item"}},[_c('span',{attrs:{"itemprop":"name"}},[_vm._v(_vm._s(_vm.item.name))])]),_c('meta',{attrs:{"itemprop":"position","content":"3"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }